import * as angular from "angular";
import {IController} from "angular";


export class OrganizationsTableRowCtrl implements IController {
  organizationsTableCtrl: IController;
  organization: any;

  constructor() {
  }
}

angular
  .module('bringoz.admin.organizations')
  .component('organizationsTableRow', {
    require: {
      organizationsTableCtrl: '^organizationsTable'
    },
    bindings: {
      organization: '<'
    },
    template: require('./organizations-table-row.html').default,
    controller: OrganizationsTableRowCtrl
  });
